import React from 'react';

const JS_RegExp_Quantifiers = () => {
  return (
    <div >
      <h1>JS_RegExp_Quantifiers</h1>
      <p>Placeholder component for: "JS RegExp Quantifiers"</p>
    </div>
  );
};

export default JS_RegExp_Quantifiers;
